import React from 'react';
import PropTypes from 'prop-types';
import logoImage from '../../assets/images/logo.png';

const Logo = ({ className = '' }) => (
  <div className={`flex flex-col items-center ${className}`}>
    <img
      src={logoImage}
      alt="Personal Therapy"
      className="w-auto h-12 mb-2"
    />
  </div>
);

Logo.propTypes = {
  className: PropTypes.string
};

export default Logo;